var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card__controls" },
        [
          _c(
            "button",
            {
              staticClass: "btn-success",
              attrs: { type: "button" },
              on: { click: _vm.agregarAbono }
            },
            [
              _c("i", { staticClass: "fa fa-plus" }),
              _vm._v(" "),
              _c("span", [_vm._v("Agregar")])
            ]
          ),
          _vm._v(" "),
          _c(
            "modal",
            {
              attrs: {
                name: "abono",
                height: "auto",
                width: "60%",
                scrollable: ""
              }
            },
            [
              _c("abono", {
                attrs: { saldo: _vm.saldo, idComprobante: _vm.idComprobante },
                on: { aceptar: _vm.aceptarAbono, cancelar: _vm.cancelarAbono },
                model: {
                  value: _vm.selectedAbono,
                  callback: function($$v) {
                    _vm.selectedAbono = $$v
                  },
                  expression: "selectedAbono"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-responsive" },
      [
        _c("vue-good-table", {
          attrs: {
            columns: [
              {
                label: "Fecha",
                field: "fecha_abono",
                filterable: true
              },
              {
                label: "Tipo",
                field: "descripcion_tipo_abono",
                filterable: true
              },
              {
                label: "Valor",
                field: "valor",
                filterable: true,
                type: "decimal"
              },
              {
                label: "Obs./Referencia",
                field: "obs_referencia"
              },
              {
                label: "Banco/Retención",
                field: "banco_retencion"
              },
              {
                label: "Acciones",
                field: "actions"
              }
            ],
            rows: _vm.abonos,
            "search-options": {
              enabled: true,
              placeholder: "Buscar..."
            },
            "pagination-options": {
              enabled: false
            },
            styleClass: "vgt-table"
          },
          scopedSlots: _vm._u([
            {
              key: "table-row",
              fn: function(props) {
                return [
                  props.column.field == "actions"
                    ? _c("span", [
                        _c(
                          "button",
                          {
                            staticClass: "btn-info btn--text",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.editarAbono(props.index)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-edit" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn-danger btn--text",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.eliminarAbono(props.index)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-trash" })]
                        )
                      ])
                    : props.column.field == "fecha_abono"
                    ? _c("span", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm
                                .moment(
                                  new Date(
                                    props.formattedRow[props.column.field]
                                  )
                                )
                                .format("DD/MM/YYYY")
                            ) +
                            "\n        "
                        )
                      ])
                    : _c("span", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              props.column.prefijo != undefined ? "$" : ""
                            ) +
                            _vm._s(
                              !props.column.numeric
                                ? props.formattedRow[props.column.field]
                                : parseFloat(
                                    props.formattedRow[props.column.field]
                                  ).toLocaleString(_vm.locale)
                            ) +
                            "\n        "
                        )
                      ])
                ]
              }
            }
          ])
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-2" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-md-4" },
        [
          _c(
            "input-field",
            {
              attrs: {
                vMoney: "",
                format: _vm.money,
                placeholder: "$ ##.##",
                readonly: "",
                id: "totalAbonado"
              },
              model: {
                value: _vm.totalAbonado,
                callback: function($$v) {
                  _vm.totalAbonado = $$v
                },
                expression: "totalAbonado"
              }
            },
            [_c("span", [_vm._v("Total abonado")])]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-xs-12 col-md-4" },
        [
          _c(
            "input-field",
            {
              attrs: {
                vMoney: "",
                format: _vm.money,
                placeholder: "$ ##.##",
                readonly: "",
                id: "totalAbonado"
              },
              model: {
                value: _vm.totalComprobante,
                callback: function($$v) {
                  _vm.totalComprobante = $$v
                },
                expression: "totalComprobante"
              }
            },
            [_c("span", [_vm._v("Total de comprobante")])]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-xs-12 col-md-4" },
        [
          _c(
            "input-field",
            {
              attrs: {
                vMoney: "",
                format: _vm.money,
                placeholder: "$ ##.##",
                readonly: "",
                id: "totalAbonado"
              },
              model: {
                value: _vm.saldo,
                callback: function($$v) {
                  _vm.saldo = $$v
                },
                expression: "saldo"
              }
            },
            [_c("span", [_vm._v("Saldo")])]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Lista de abonos realizados")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa2b5164", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa2b5164","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/ListaAbonos.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-aa2b5164","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/ListaAbonos.vue
// module chunks = 0